module.exports = __webpack_public_path__ + "img/avatar7.eed5c2f7.png";